import { inject, Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { environment } from 'src/environments/environment';
import { ImportSharedDataResponse, SharedDataImportPreview } from './shared-data-import.model';

@Injectable({ providedIn: 'root' })
export class SharedDataImportService {
  private readonly http = inject(HttpService);
  private readonly apiBase = `${environment.adminConfig.apiUri}/shareddata`;

  /** Rækketal pr. tabel i kilden (forrige miljø) og målet (dette miljø). */
  getPreview(): Promise<SharedDataImportPreview> {
    return this.http.get<SharedDataImportPreview>(`${this.apiBase}/import/preview`);
  }

  /** Tømmer de faste tabeller i dette miljø og erstatter dem 1:1 med det forrige miljøs indhold. */
  import(): Promise<ImportSharedDataResponse> {
    return this.http.post<ImportSharedDataResponse, null>(`${this.apiBase}/import`, null);
  }
}
